import { Button, Modal, Typography, message, Carousel } from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";

import http from "@/utils/http";
import api from "@/utils/api";
import "./modal.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
const LuanchModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const carouselRef = useRef();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editable, setEditable] = useState(false);
  const [carouselVisible, setCarouselVisible] = useState(false);
  const [dragCarouselList, setDragCarouselList] = useState([]);
  const [textList, setTextList] = useState([]);
  const [carouselList, setCarouselList] = useState([]);
  useImperativeHandle(ref, () => ({
    openModal: async (record) => {
      try {
        setCarouselList([]);
        setTextList([]);
        setVisible(true);
        console.log("record", record);
        await fetchDate(record.id);
      } catch (error) {
        message.error("Failed to fetch user data");
      } finally {
        setLoading(false);
      }
    },
  }));

  const fetchDate = async (id) => {
    try {
      setLoading(true);
      const response = await http.get(api.getAppDetail, {
        params: { ids: id },
      });

      if (response.code === "1" && response.data?.textList) {
        console.log(response.data.carouselList);
        setTextList(response.data.textList);
        setCarouselList(response.data.carouselList);
      }
    } finally {
      setLoading(false);
    }
  };
  // text拖拽完成事件
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const newList = Array.from(textList);
    const [moved] = newList.splice(result.source.index, 1);
    newList.splice(result.destination.index, 0, moved);

    setTextList(newList);
  };
  const handleCarouselClick = () => {
    setDragCarouselList([...carouselList]); // 拖拽用的副本
    setCarouselVisible(true);
  };

  const handleCarouselDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(dragCarouselList);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setDragCarouselList(reordered);
  };
  // 提交
  const handleSubmit = async () => {
    try {
      setLoading(true);

      const finalCarouselList = (
        dragCarouselList.length > 0 ? dragCarouselList : carouselList
      ).map((item, index) => ({
        id: item.id,
        // status: item.status ?? 1,
        status: 1,
        sort: index + 1,
      }));

      const finalTextList = textList.map((item, index) => ({
        id: item.id,
        // status: item.status ?? 1,
        status: 1,
        sort: index + 1,
      }));

      const payload = {
        carouselList: finalCarouselList,
        textList: finalTextList,
      };

      const res = await http.post(api.getAppUpdateStatus, payload);

      if (res.code === "1") {
        message.success("Submitted successfully.");
        setVisible(false);
        setCarouselVisible(false);
        onSuccess?.();
      } else {
        message.error("Submission failed.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        title={
          <Typography.Title
            level={4}
            style={{ textAlign: "left", marginLeft: 10 }}
          >
            LAUNCH ADVERTISING
          </Typography.Title>
        }
        open={visible}
        onCancel={() => {
          setVisible(false);
          setEditable(false);
          setCarouselList([]);
          setTextList([]);
        }}
        footer={
          <div
            style={{ display: "flex", justifyContent: "center", gap: "12px" }}
          >
            <Button
              key="back"
              onClick={() => {
                setVisible(false);
                setCarouselList([]);
                setTextList([]);
              }}
            >
              Cancel
            </Button>
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={handleSubmit}
              disabled={loading}
            >
              Submit
            </Button>
          </div>
        }
        width="25vw"
        styles={{
          body: {
            maxHeight: "80vh",
            overflowY: "auto",
          },
        }}
        destroyOnClose
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "80vh",
            width: "100%",
            gap: "16px",
          }}
        >
          <div
            className="model_top"
            style={{ width: "100%", marginBottom: "16px" }}
          ></div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              marginBottom: "8px",
            }}
          >
            Sponsors
          </div>
          <div
            className="carousel_content"
            style={{
              borderRadius: "12px",
            }}
          >
            <Carousel ref={carouselRef} autoplay dots={true}>
              {carouselList.map((item) => {
                const file = item.fileUrlList?.[0]?.fileUrl;
                if (!file) return null;

                const isVideo =
                  item.fileUrlList[0]?.contentType?.startsWith("video");

                return (
                  <div
                    key={item.id}
                    style={{ cursor: "pointer" }}
                    onClick={handleCarouselClick}
                  >
                    {isVideo ? (
                      <video
                        src={file}
                        muted
                        autoPlay
                        controls
                        onEnded={() => carouselRef.current?.next()}
                        style={{
                          width: "100%",
                          height: "300px",
                          borderRadius: "12px",
                        }}
                      />
                    ) : (
                      <img
                        src={file}
                        alt={item.title}
                        style={{
                          width: "100%",
                          height: "300px",
                          borderRadius: "12px",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </Carousel>
          </div>

          <div style={{ width: "100%" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginBottom: "8px",
              }}
            >
              Discover More
            </div>
            <div
              className="text_content"
              style={{
                borderRadius: "12px",
                padding: "12px",
              }}
            >
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {textList.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                display: "flex",
                                alignItems: "stretch",
                                background: "#f5f5f5",
                                borderRadius: "8px",
                                padding: "12px",
                                marginBottom: "12px",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div style={{ flex: 8, paddingRight: "10px" }}>
                                <h3
                                  style={{
                                    margin: 0,
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item.title}
                                </h3>
                                <p
                                  style={{
                                    marginTop: "6px",
                                    color: "#333",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {item.content}
                                </p>
                              </div>
                              <div
                                style={{
                                  flex: 2,
                                  textAlign: "center",
                                  margin: "auto",
                                  height: "80px",
                                }}
                              >
                                {item.fileUrlList &&
                                item.fileUrlList[0]?.fileUrl ? (
                                  <img
                                    src={item.fileUrlList[0].fileUrl}
                                    alt="preview"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "contain",
                                      borderRadius: "6px",
                                    }}
                                  />
                                ) : (
                                  <div
                                    style={{ color: "#999", fontSize: "12px" }}
                                  >
                                    No picture
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title="Reorder Carousel"
        open={carouselVisible}
        zIndex={2000}
        onCancel={() => setCarouselVisible(false)}
        onOk={() => {
          setCarouselList(dragCarouselList);
          setCarouselVisible(false);
        }}
        styles={{
          body: {
            maxHeight: "70vh",
            overflowY: "auto",
          },
        }}
      >
        <DragDropContext onDragEnd={handleCarouselDragEnd}>
          <Droppable droppableId="carousel-droppable">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {dragCarouselList.map((item, index) => {
                  const file = item.fileUrlList?.[0]?.fileUrl;
                  if (!file) return null;

                  const isVideo =
                    item.fileUrlList[0]?.contentType?.startsWith("video");

                  return (
                    <Draggable
                      key={item.id}
                      draggableId={item.id.toString()}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f5f5f5",
                            borderRadius: "8px",
                            padding: "12px",
                            marginBottom: "12px",
                            ...provided.draggableProps.style,
                          }}
                        >
                          {isVideo ? (
                            <video
                              src={file}
                              muted
                              controls
                              style={{
                                width: "100px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "6px",
                                marginRight: "10px",
                              }}
                            />
                          ) : (
                            <img
                              src={file}
                              alt="carousel"
                              style={{
                                width: "100px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "6px",
                                marginRight: "10px",
                              }}
                            />
                          )}
                          <span>{item.title || `ID: ${item.id}`}</span>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Modal>
    </>
  );
});

export default LuanchModal;
